'use strict'

/**
 *
 * @name: nnBaseFieldLabel
 *
 */

import DirectiveTemplate from './nn-base-field-label.directive.html'
import './nn-base-field-label.directive.scss'

function NnBaseFieldLabel () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: DirectiveTemplate,
  }
}

export default NnBaseFieldLabel



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-field-label/nn-base-field-label.directive.js